import { captureError } from './utils';

/**
 * Initialize global error handlers
 * Call this in your root layout or _app
 */
export function initErrorHandlers() {
  if (typeof window === 'undefined') return;

  // Unhandled errors
  window.addEventListener('error', (event) => {
    captureError(event.error || event.message, 'error', {
      route: window.location.pathname,
      meta: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  // Unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    captureError(event.reason, 'error', {
      route: window.location.pathname,
      meta: {
        type: 'unhandledRejection',
      },
    });
  });
}

